import { render, staticRenderFns } from "./equipe-diretiva.vue?vue&type=template&id=5f94292a"
import script from "./equipe-diretiva.vue?vue&type=script&lang=js"
export * from "./equipe-diretiva.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports